import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { KeycloakProvider } from "keycloak-react-web";
import authInstance from "./Keycloak";
import { Provider } from "react-redux";
import store from "./stores/store";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  // <React.StrictMode>
  <KeycloakProvider
    client={authInstance}
    initOptions={{
      onLoad: "check-sso",
      checkLoginIframe: false,
    }}
  >
    <Provider store={store}>
      <App />
    </Provider>
  </KeycloakProvider>,
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
